<template>
    <div>
    </div>
</template>

<script>
    

    export default {
        name: "onsaleHomeRedirectPage",

        data() {
            return {

            }
        },

        created() {
            this.doRedirect();
        },

        methods: {
            doRedirect() {
                this.$router.push({
                    name: 'OnsaleHome'
                })
            },
        },
    }
</script>

<style scoped>

</style>